import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@skgrouploans.online");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") { toast.error("Not an admin account"); return; }
      toast.success("Logged in"); nav("/admin");
    } catch (err) { toast.error(formatErr(err)); } finally { setLoading(false); }
  };
  return (
    <div data-testid="admin-login" className="min-h-screen bg-[#0B0B0B] flex items-center justify-center px-6">
      <div className="max-w-md w-full sk-card-dark p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src="/assets/sk-logo.jpeg" className="w-14 h-14 rounded-full ring-1 ring-[#D4AF37]/40"/>
          <div>
            <div className="font-display text-2xl text-white">SK Group</div>
            <div className="text-xs tracking-[0.3em] text-[#D4AF37] uppercase">Admin Console</div>
          </div>
        </div>
        <div className="inline-flex items-center gap-2 sk-badge sk-badge-gold"><ShieldCheck size={12}/> Restricted access</div>
        <h1 className="mt-4 font-display text-3xl text-white">Sign in</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <div className="text-xs uppercase tracking-widest text-white/50 mb-2">Admin email</div>
            <input data-testid="admin-login-email" required type="email" className="sk-input" value={email} onChange={(e)=>setEmail(e.target.value)}/>
          </label>
          <label className="block">
            <div className="text-xs uppercase tracking-widest text-white/50 mb-2">Password</div>
            <input data-testid="admin-login-password" required type="password" className="sk-input" value={password} onChange={(e)=>setPassword(e.target.value)}/>
          </label>
          <button data-testid="admin-login-submit" disabled={loading} className="sk-btn-gold w-full">{loading?"Signing in...":"Login"}</button>
        </form>
        <div className="mt-5 text-center text-sm">
          <Link data-testid="admin-forgot-link" to="/admin/forgot-password" className="text-white/60 hover:text-[#D4AF37]">Forgot password?</Link>
        </div>
      </div>
    </div>
  );
}
